module.exports = __webpack_public_path__ + "static/media/squiggles.a81247d0.png";